module.exports = __webpack_public_path__ + "static/media/GUARD.7b494877.svg";